import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from '@/layouts/MainLayout'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const routes = [{
	path: '/',
	component: MainLayout,
	meta: {
		title: '高报升学',
		keepAlive: false
	},
	children: [{
			path: '/',
			name: 'Home',
			meta: {
				title: '高报升学',
				keepAlive: true
			},
			component: () => import('@/views/HomePage')
		},
		{
			path: 'wechatcall',
			name: 'WechatCallback',
			component: () => import('@/views/WechatCallback'),
			meta: {
				title: '微信登录回调'
			}
		},
		{
			path: 'banner/:id',
			name: 'BannerDetail',
			meta: {
				title: '详情',
				keepAlive: false
			},
			component: () => import('@/views/BannerDetail')
		},

		{
			path: 'profession',
			name: 'ProfessionQuery',
			meta: {
				title: '职业查询',
				keepAlive: false
			},
			component: () => import('@/views/ProfessionQuery')
		},
		{
			path: 'profession/:id',
			name: 'ProfessionDetail',
			meta: {
				title: '职业详情',
				keepAlive: false
			},
			component: () => import('@/views/ProfessionDetail')
		},

		{
			path: 'upgrade',
			name: 'UpgradePlan',
			meta: {
				title: '升本计划',
				keepAlive: false
			},
			component: () => import('@/views/UpgradePlan')
		},
		{
			path: 'graduate',
			name: 'GraduateQuery',
			meta: {
				title: '考研查询',
				keepAlive: false
			},
			component: () => import('@/views/GraduateQuery')
		},
		{
			path: 'news',
			name: 'NewsList',
			meta: {
				title: '新闻',
				keepAlive: false
			},
			component: () => import('@/views/news/NewsList')
		},
		{
			path: 'news/:id',
			name: 'NewsDetail',
			meta: {
				title: '新闻详情',
				keepAlive: false
			},
			component: () => import('@/views/news/NewsDetail')
		},
		{
			path: 'service',
			name: 'ServiceList',
			meta: {
				title: '服务',
				keepAlive: false
			},
			component: () => import('@/views/news/ServiceList')
		},
		{
			path: 'school',
			name: 'SchoolList',
			meta: {
				title: '查大学',
				keepAlive: false
			},
			component: () => import('@/views/school/SchoolList')
		},
		{
			path: 'school/:id',
			name: 'SchoolDetail',
			meta: {
				title: '学校详情',
				keepAlive: false
			},
			component: () => import('@/views/school/SchoolDetail'),
			children: [{
					path: '',
					redirect: 'overview'
				},
				{
					path: 'overview',
					name: 'SchoolOverview',
					meta: {
						title: '学校概况',
						keepAlive: false
					},
					component: () => import('@/views/school/SchoolOverview')
				},
				{
					path: 'score',
					name: 'SchoolScore',
					meta: {
						title: '历年分数',
						keepAlive: false
					},
					component: () => import('@/views/school/SchoolScore')
				},
				{
					path: 'plan',
					name: 'SchoolPlan',
					meta: {
						title: '招生计划',
						keepAlive: false
					},
					component: () => import('@/views/school/SchoolPlan')
				},
				{
					path: 'major',
					name: 'SchoolMajor',
					meta: {
						title: '专业介绍',
						keepAlive: false
					},
					component: () => import('@/views/school/SchoolMajor')
				},
				{
					path: 'majordetail',
					name: 'SchoolMajorDetail',
					meta: {
						title: '开设专业详情',
						keepAlive: false
					},
					component: () => import('@/views/school/SchoolMajorDetail')
				},
				{
					path: 'intro',
					name: 'SchoolIntro',
					meta: {
						title: '学校简介',
						keepAlive: false
					},
					component: () => import('@/views/school/SchoolIntro')
				},
				{
					path: 'life',
					name: 'SchoolLife',
					meta: {
						title: '校园生活',
						keepAlive: false
					},
					component: () => import('@/views/school/SchoolLife')
				},
			]
		},
		{
			path: 'special',
			name: 'SpecialList',
			meta: {
				title: '查专业',
				keepAlive: false
			},
			component: () => import('@/views/special/SpecialList')
		},
		{
			path: 'special/:id',
			name: 'SpecialDetail',
			meta: {
				title: '专业详情',
				keepAlive: false
			},
			component: () => import('@/views/special/SpecialDetail'),
			children: [{
					path: '',
					redirect: 'overview'
				},
				{
					path: 'overview',
					name: 'SpecialOverview',
					meta: {
						title: '专业概况',
						keepAlive: false
					},
					component: () => import('@/views/special/SpecialOverview')
				},
				{
					path: 'school',
					name: 'SpecialSchool',
					meta: {
						title: '开设院校',
						keepAlive: false
					},
					component: () => import('@/views/special/SpecialSchool')
				},
				{
					path: 'relevant',
					name: 'SpecialRelevant',
					meta: {
						title: '相关专业',
						keepAlive: false
					},
					component: () => import('@/views/special/SpecialRelevant')
				},
			]
		},


		// 下面这些全部加 needLogin: true

		{
			path: 'search',
			name: 'SearchPage',
			meta: {
				title: '搜索',
				keepAlive: false,
				needLogin: true
			},
			component: () => import('@/views/SearchPage')
		},
		{
			path: 'same',
			name: 'SameScore',
			meta: {
				title: '同分去向',
				keepAlive: false,
				needLogin: true
			},
			component: () => import('@/views/SameScore')
		},
		{
			path: 'line',
			name: 'LineQuery',
			meta: {
				title: '批次线查询',
				keepAlive: false,
				needLogin: true
			},
			component: () => import('@/views/LineQuery')
		},
		{
			path: 'rank',
			name: 'RankQuery',
			meta: {
				title: '位次查询',
				needLogin: true
			},
			component: () => import('@/views/RankQuery')
		},
		{
			path: 'srank',
			name: 'SchoolRank',
			meta: {
				title: '院校排行榜',
				keepAlive: false,
				needLogin: true
			},
			component: () => import('@/views/SchoolRank')
		},
		{
			path: 'volunteer',
			name: 'VolunteerPage',
			meta: {
				title: '志愿填报',
				needLogin: true
			},
			component: () => import('@/views/volunteer/VolunteerPage'),
			children: [{
				path: 'my',
				name: 'VolunteerMy',
				meta: {
					title: '我的志愿表',
					needLogin: true
				},
				component: () => import('@/views/volunteer/VolunteerMy')
			}]
		},
		{
			path: 'intellect',
			name: 'VolunteerInt',
			meta: {
				title: '智能生成',
				needLogin: true
			},
			component: () => import('@/views/volunteer/VolunteerInt')
		},
		{
			path: 'pool',
			name: 'VolunteerPool',
			meta: {
				title: 'svip志愿填报',
				needLogin: true
			},
			component: () => import('@/views/volunteer/VolunteerPool')
		},

		{
			path: 'course',
			name: 'CourseList',
			meta: {
				title: '高报学堂',
				needLogin: false
			},
			component: () => import('@/views/course/CourseList')
		},
		{
			path: 'course/:id',
			name: 'CourseDetail',
			meta: {
				title: '学堂详情',
				needLogin: true
			},
			component: () => import('@/views/course/CourseDetail')
		},
		{
			path: 'evaluate',
			name: 'EvaluateList',
			meta: {
				title: '测评列表',
				needLogin: false
			},
			component: () => import('@/views/evaluate/EvaluateList')
		},
		{
			path: 'evaluate/detail/:id',
			name: 'EvaluateDetail',
			meta: {
				title: '测评详情',
				needLogin: true
			},
			component: () => import('@/views/evaluate/EvaluateDetail')
		},
		{
			path: 'evaluate/answer/:id',
			name: 'EvaluateAnswer',
			meta: {
				title: '开始测评',
				needLogin: true
			},
			component: () => import('@/views/evaluate/EvaluateAnswers')
		},
		{
			path: 'evaluate/person/:id',
			name: 'EvaluatePerson',
			meta: {
				title: '测评',
				needLogin: true
			},
			component: () => import('@/views/evaluate/EvaluatePerson')
		},
		{
			path: 'user',
			name: 'UserPage',
			meta: {
				title: '我的',
				needLogin: true
			},
			component: () => import('@/views/user/UserPage'),
			children: [{
					path: '',
					redirect: 'profile'
				},
				{
					path: 'profile',
					name: 'UserProfile',
					meta: {
						title: '个人信息',
						needLogin: true
					},
					component: () => import('@/views/user/UserProfile')
				},
				{
					path: 'score',
					name: 'UserScore',
					meta: {
						title: '成绩录入',
						needLogin: true
					},
					component: () => import('@/views/user/UserScore')
				},
				{
					path: 'evaluate',
					name: 'UserEvaluate',
					meta: {
						title: '我的测评',
						needLogin: true
					},
					component: () => import('@/views/user/UserEvaluate')
				},
				{
					path: 'study',
					name: 'UserStudy',
					meta: {
						title: '学习记录',
						needLogin: true
					},
					component: () => import('@/views/user/UserStudy')
				},
				{
					path: 'vip',
					name: 'UserVip',
					meta: {
						title: '我的订单',
						needLogin: true
					},
					component: () => import('@/views/user/UserVip')
				},
				{
					path: 'collect',
					name: 'UserCollect',
					meta: {
						title: '我的收藏',
						needLogin: true
					},
					component: () => import('@/views/user/UserCollect')
				},
				{
					path: 'plan',
					name: 'UserPlan',
					meta: {
						title: '升学规划',
						needLogin: true
					},
					component: () => import('@/views/user/UserPlan')
				},
				{
					path: 'help',
					name: 'UserHelp',
					meta: {
						title: '帮助中心',
						needLogin: true
					},
					component: () => import('@/views/user/UserHelp')
				},
				{
					path: 'feedback',
					name: 'UserFeedback',
					meta: {
						title: '意见反馈',
						needLogin: true
					},
					component: () => import('@/views/user/UserFeedback')
				},
				{
					path: 'agreement',
					name: 'UserAgreement',
					meta: {
						title: '平台协议',
						needLogin: true
					},
					component: () => import('@/views/user/UserAgreement')
				},
				{
					path: 'about',
					name: 'UserAbout',
					meta: {
						title: '关于我们',
						needLogin: true
					},
					component: () => import('@/views/user/UserAbout')
				},
			]
		}
	]
}]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		return savedPosition || {
			x: 0,
			y: 0
		}
	}
})
// 全局守卫 
router.beforeEach((to, from, next) => {
	document.title = to.meta.title || '高报升学'

	// 需要登录
	if (to.meta.needLogin) {
		const token = localStorage.getItem('token')
		if (!token) {
			// 弹出登录
			Vue.prototype.$bus.$emit('showLoginModal')
			// 跳转到首页
			// next('/')
			return
		}
	}

	next()
})

export default router